<template>
    <div class="component-group"
         :class="{
            active: !!isStatusOther
         }"
    >
        <form-group :label="`${$t(`${translationsGroup}.membership_type`)}`"
                    :errors="errors"
                    label-for="membershipType"
                    name="membershipType"
        >
            <select-box :options="getOptions"
                        :value="status"
                        :disabled="isLoading"
                        :placeholder="`${$t(`${placeholderGroup}.select_option`)}`"
                        id="membershipType"
                        name="membershipType"
                        @update="onUpdateBloodDonorStatus"
            />
        </form-group>
        <form-group v-if="!!isStatusOther"
                    :label="`${$t(`${placeholderGroup}.enter_other_status`)}`"
                    :errors="errors"
                    name="membershipType"
        >
            <input :value="statusOther"
                   name="membershipTypeOther"
                   class="blood-donors-create-update-input"
                   :placeholder="$t(`${placeholderGroup}.enter_other_status`)"
                   @input="onUpdateBloodDonorStatus('membershipTypeOther', $event.target.value)"
            />
        </form-group>
    </div>
</template>

<script>
import SelectBox from '../../../../../../Components/Forms/SelectBox/SelectBox';
import FormGroup from '../../../../../../Components/Forms/Holders/FormGroup';

export default {
    name: 'MembershipTypeSelect',
    emits: [
        'update',
    ],
    components: {
        SelectBox,
        FormGroup
    },
    props: {
        status: {},
        statusOther: {},
        errors: {
            default: null
        },
        translationsGroup: {
            type: String,
            default: 'words'
        },
        placeholderGroup: {
            type: String,
            default: 'placeholders'
        },
    },
    data() {
        return {
            isLoading: false,
            options: [],
        };
    },
    computed: {
        getOptions() {
            return [
                ...this.options,
                {
                    'label': this.$t('words.other'),
                    'value': 'other'
                }
            ];
        },
        isStatusOther() {
            return this.status === 'other';
        },
    },
    methods: {
        async fetchMembershipTypes() {
            this.isLoading = true;

            try {
                const response = await window.axios.get('/blood-donors/membership-types');

                this.options = response.data.data;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;

                this.$toastException(error);
            }
        },
        onUpdateBloodDonorStatus(name, value) {
            this.$emit('update', name, value);
        },
    },
    async created() {
        await this.fetchMembershipTypes();
    }
}
</script>